// This file is auto-generated by scripts/generate-cache-keys.ts
// DO NOT EDIT MANUALLY - this file is regenerated on build

import type { KeyingConfig } from "@urql/exchange-graphcache";

/**
 * Auto-generated keys configuration for GraphQL types without id fields.
 * 
 * Why this exists:
 * urql's GraphQL cache requires unique keys for each entity type to properly normalize
 * and cache data. Types without `id` or `_id` fields cause "Invalid key" warnings because
 * the cache cannot generate unique identifiers for them.
 * 
 * By returning `null` for these types, we tell the cache to embed them directly in their
 * parent query results rather than trying to cache them separately. This eliminates the
 * warnings and ensures proper cache behavior.
 * 
 * This configuration is automatically generated from schema.graphql by parsing all type
 * definitions and identifying those without id fields. The script runs during the build
 * process (via `pnpm run type-gen`) to keep it in sync with schema changes.
 * 
 * See: scripts/generate-cache-keys.ts
 */
export const generatedCacheKeys: KeyingConfig = {
  // Special case: FeedArticleTagsByFeedType uses composite key
  FeedArticleTagsByFeedType: (data) => {
    // Create a composite key from tag and tagKind fields
    if (
      data &&
      typeof data === "object" &&
      "tag" in data &&
      "tagKind" in data
    ) {
      return `${data.tagKind}:${data.tag}`;
    }
    return null;
  },
  AIPerceptionLLMLensType: (_data) => null,
  AIPerceptionResponseGrokType: (_data) => null,
  AIPerceptionResponseType: (_data) => null,
  AIPerceptionSummaryGrokType: (_data) => null,
  AIPerceptionSummaryType: (_data) => null,
  AddArticleUrlStatusType: (_data) => null,
  AddBriefingArticleExclusionsPayload: (_data) => null,
  AdditionalInsightsV2Type: (_data) => null,
  ArticleMention: (_data) => null,
  ArticlePublisher: (_data) => null,
  ArticleSentimentType: (_data) => null,
  ArticleSocialType: (_data) => null,
  ArticleSubscriptionStatusType: (_data) => null,
  ArticleSummaryType: (_data) => null,
  AudienceAnalysisV2Type: (_data) => null,
  AudienceInterpretationDetailType: (_data) => null,
  AudienceInterpretationType: (_data) => null,
  AudiencePerceptionAnalysisV2Type: (_data) => null,
  AuthTokens: (_data) => null,
  AuthorNameType: (_data) => null,
  BlogPostV2Type: (_data) => null,
  BotAnalysisType: (_data) => null,
  BriefingDefinitionConnection: (_data) => null,
  BriefingDefinitionEdge: (_data) => null,
  BriefingDefinitionImageAsset: (_data) => null,
  BriefingDefinitionSchedule: (_data) => null,
  BriefingPDFPreviewResponse: (_data) => null,
  BriefingRecipientDelivery: (_data) => null,
  BriefingRunConnection: (_data) => null,
  BriefingRunEdge: (_data) => null,
  BriefingSlotBinding: (_data) => null,
  BriefingTableOffsetPaginated: (_data) => null,
  BriefingTemplateConnection: (_data) => null,
  BriefingTemplateEdge: (_data) => null,
  BroadcastClipTypeOffsetPaginated: (_data) => null,
  BroadcastProgramTypeOffsetPaginated: (_data) => null,
  BroadcastStationTypeOffsetPaginated: (_data) => null,
  CSVExportResponse: (_data) => null,
  CSVUploadProgress: (_data) => null,
  ChannelRecommendationType: (_data) => null,
  ChannelRecommendationV2Type: (_data) => null,
  ChannelStrategyV2Type: (_data) => null,
  CitationGrokType: (_data) => null,
  CitationMixSummaryV2Type: (_data) => null,
  CitationPackageV2Type: (_data) => null,
  CitationType: (_data) => null,
  CitationV2Type: (_data) => null,
  ContentExamplesGrokType: (_data) => null,
  ContentExamplesType: (_data) => null,
  ContentRecommendationV2Type: (_data) => null,
  ConversationType: (_data) => null,
  ConversationTypeOffsetPaginated: (_data) => null,
  CountryType: (_data) => null,
  CrisisQAV2Type: (_data) => null,
  CrisisRecommendationsType: (_data) => null,
  CrisisScenarioType: (_data) => null,
  CustomerCommsStrategyV2Type: (_data) => null,
  CustomerPartnerCommsStrategyType: (_data) => null,
  DailyStreamgraphData: (_data) => null,
  DemographicFramingV2Type: (_data) => null,
  DemographicInterpretationType: (_data) => null,
  DiscoveredFeedTagType: (_data) => null,
  DjangoImageType: (_data) => null,
  DjangoModelType: (_data) => null,
  DraftCollectionV2Type: (_data) => null,
  DryRunResultType: (_data) => null,
  EarnedMediaExampleType: (_data) => null,
  EarnedMediaTierType: (_data) => null,
  ExecutiveOverviewBulletType: (_data) => null,
  ExecutiveOverviewType: (_data) => null,
  ExecutiveOverviewV2Type: (_data) => null,
  ExecutiveQuoteV2Type: (_data) => null,
  ExecutiveRiskSummaryType: (_data) => null,
  FeedArticleListResponse: (_data) => null,
  FeedArticleMentionType: (_data) => null,
  FeedArticleProjectionListResponse: (_data) => null,
  FeedArticleProjectionTypeConnection: (_data) => null,
  FeedArticleProjectionTypeEdge: (_data) => null,
  FeedArticleProjectionTypeOffsetPaginated: (_data) => null,
  FeedArticleScoreType: (_data) => null,
  FeedArticleSentimentType: (_data) => null,
  FeedLastLocationType: (_data) => null,
  FeedPageV2: (_data) => null,
  FeedSpecificSummaryType: (_data) => null,
  FeedStats: (_data) => null,
  FilterItem: (_data) => null,
  GrokContentExamplesType: (_data) => null,
  GrokInfluencerStrategyType: (_data) => null,
  GrokInfluencerType: (_data) => null,
  GrokNarrativeIntelligenceResponseType: (_data) => null,
  GrokNarrativeRecommendationsType: (_data) => null,
  GrokRiskAnalysisType: (_data) => null,
  HumanAudienceAnalysisType: (_data) => null,
  HumanNarrativeFramingType: (_data) => null,
  InfluencerStrategyType: (_data) => null,
  InfluencerType: (_data) => null,
  InternalCommsStrategyType: (_data) => null,
  InternalCommsStrategyV2Type: (_data) => null,
  JournalistOutreachEmailV2Type: (_data) => null,
  JournalistQAType: (_data) => null,
  JournalistQAV2Type: (_data) => null,
  KMMetricType: (_data) => null,
  KeyMessageInsightUpdate: (_data) => null,
  LLMPerceptionAnalysisV2Type: (_data) => null,
  LLMPerceptionGenerationResultType: (_data) => null,
  LoginResponse: (_data) => null,
  MediaFilterItem: (_data) => null,
  MediaFilters: (_data) => null,
  MediaPropagationForecastV2Type: (_data) => null,
  MediaRecommendationType: (_data) => null,
  MessageType: (_data) => null,
  MessageTypeOffsetPaginated: (_data) => null,
  MetricType: (_data) => null,
  MostImpactedAudienceV2Type: (_data) => null,
  NarrativeClassificationV2Type: (_data) => null,
  NarrativeDiagnosisType: (_data) => null,
  NarrativeIntelligenceGPTUpdate: (_data) => null,
  NarrativeIntelligenceGenerationResultType: (_data) => null,
  NarrativeIntelligenceGrokUpdate: (_data) => null,
  NarrativeIntelligencePDFResponse: (_data) => null,
  NarrativeIntelligenceProgressType: (_data) => null,
  NarrativeIntelligenceReportDataV2Type: (_data) => null,
  NarrativeIntelligenceResponseType: (_data) => null,
  NarrativeLabelToneType: (_data) => null,
  NarrativePerceptionGrokUpdate: (_data) => null,
  NarrativePerceptionUpdate: (_data) => null,
  NarrativePerceptionV2Update: (_data) => null,
  NarrativeProminenceV2Type: (_data) => null,
  NarrativeRecommendationsType: (_data) => null,
  NewsAlertPDFPreviewResponse: (_data) => null,
  NewsFeedChartType: (_data) => null,
  NewsFeedSidebar: (_data) => null,
  OffsetPaginationInfo: (_data) => null,
  OperationInfo: (_data) => null,
  OperationMessage: (_data) => null,
  OverviewGrokType: (_data) => null,
  OverviewType: (_data) => null,
  OwnedMediaExampleType: (_data) => null,
  PageInfo: (_data) => null,
  PaidAmplificationExampleType: (_data) => null,
  PodcastEpisodeTypeOffsetPaginated: (_data) => null,
  PostureDeterminationV2Type: (_data) => null,
  PressReleaseV2Type: (_data) => null,
  PriorityRisksV2Type: (_data) => null,
  PublisherConfigurationType: (_data) => null,
  QAPairV2Type: (_data) => null,
  RecommendationsGrokType: (_data) => null,
  RecommendationsType: (_data) => null,
  ReputationImpactV2Type: (_data) => null,
  ReputationalRiskManagementV2Type: (_data) => null,
  ReputationalRiskType: (_data) => null,
  RiskAnalysisType: (_data) => null,
  RiskAnalysisV2Type: (_data) => null,
  SavedClipTypeOffsetPaginated: (_data) => null,
  SavedPromptType: (_data) => null,
  SavedPromptTypeOffsetPaginated: (_data) => null,
  SavedViewExportResponse: (_data) => null,
  ScenarioModelType: (_data) => null,
  ScenarioModelingV2Type: (_data) => null,
  ScenarioModelsType: (_data) => null,
  ScenarioOutcomeV2Type: (_data) => null,
  ShareVoiceSidebar: (_data) => null,
  ShareVoiceTable: (_data) => null,
  SidebarFilters: (_data) => null,
  SocialMediaExampleType: (_data) => null,
  SocialMetricsType: (_data) => null,
  StartSsoResponse: (_data) => null,
  StoryArticleOperationResult: (_data) => null,
  StoryDailyCount: (_data) => null,
  StoryInsightUpdate: (_data) => null,
  StoryInsightsData: (_data) => null,
  StoryListResponse: (_data) => null,
  StoryTypeOffsetPaginated: (_data) => null,
  StreamgraphDataset: (_data) => null,
  SuccessResponse: (_data) => null,
  TableSortingMetadata: (_data) => null,
  TemplateLayoutAsset: (_data) => null,
  TemplateLayoutConnection: (_data) => null,
  TemplateLayoutEdge: (_data) => null,
  TenantPublisherTierType: (_data) => null,
  TenantTierConfigType: (_data) => null,
  TermType: (_data) => null,
  TierConfigurationResponseType: (_data) => null,
  TierConfigurationType: (_data) => null,
  TimezoneOption: (_data) => null,
  TopXConversationsType: (_data) => null,
  TrajectoryAnalysisV2Type: (_data) => null,
  UIMessageType: (_data) => null,
  UrlCitationType: (_data) => null,
  VersBaseArticleImageType: (_data) => null,
  WhatElseYouShouldKnowType: (_data) => null,
  XPostType: (_data) => null,
};
